import React from 'react';

const Home = () => (
  <div style={{ margin: '20px' }}>
    <h2>Welcome to MasterPlan</h2>
  </div>
);

export default Home;
